import {ApiRes} from '@type/api'
import {apiPost} from '@api/api'
import {ILoginResV2} from '@type/auth'

export const apiLoginEmailWithCode = async (email: string, code: string): Promise<ApiRes<ILoginResV2>> => {
    return await apiPost(`signin/email`, {email: email, code: code})
}
